module.exports = __webpack_public_path__ + "img/index-security-bottom4.d3147ee4.svg";